import { useMutation, useQueryClient } from 'react-query';
import { applicationKeys } from '../cache-keys/applicationKeys';
import { loan_application } from '@axo/shared/data-access/types';
import { loan_quote_api } from '@axo/shared/data-access/api';
import { useAPI } from '@axo/shared/data-access/provider';

export function useActivateQuote(
  application: loan_application.LoanApplication,
  requestID: string
) {
  const client = useQueryClient();
  const api = useAPI();
  return useMutation(
    () =>
      loan_quote_api.activateLoanQuote(api)(
        requestID,
        application.MarketCountry
      ),
    {
      onSuccess: () =>
        client.invalidateQueries(
          applicationKeys.loanQuotes({
            applicationID: application.ID,
          })
        ),
    }
  );
}
